import React, { useEffect, useState } from "react";
import Modal from "../../Modal";
import { Button } from "@mui/material";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";

const btnStyle = {
  background: "transparent",
  width: "65px",
  height: "65px",
  border: "1px solid lightblue",
};

const AttachmentModal = ({
  show,
  handleClose,
  attachments = [],
  defaultSelected =0
}) => {

  const [selectedImage, setSelectedImage] = useState(defaultSelected);
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    setSelectedImage(defaultSelected);
  }, [defaultSelected]);
  
  const handleSlideChange = (type) => {
    if (type === "prev") {
      if (selectedImage === 0) {
        setSelectedImage(attachments.length - 1);
      } else {
        setSelectedImage(selectedImage - 1);
      }
    } else {
      if (selectedImage === attachments.length - 1) {
        setSelectedImage(0);
      } else {
        setSelectedImage(selectedImage + 1);
      }
    }
  };

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = () => {
    setIsLoading(false); // Optionally handle error state separately
  };
  return (
    <Modal
      open={show}
      width="xl"
      handleClose={handleClose}
      modalTitle="Attachments"
      action={() => (
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleClose}
          title="Close"
        >
          Close
        </Button>
      )}
    >
      <Container>
        <Row className="align-items-center">
          <Col md="1" className="text-center">
            <Button
              disabled={attachments.length <= 1}
              onClick={() => handleSlideChange("prev")}
              style={{ ...btnStyle }}
            >
              <KeyboardArrowLeft />
            </Button>
          </Col>

          <Col md="10" className="text-center py-5">
            {attachments &&
              attachments.map((att, index) => (
                <div
                  key={att.id}
                  style={{
                    display: selectedImage === index ? "block" : "none",
                    maxWidth: "100%",
                    maxHeight: "500px",
                    margin: "auto",
                  }}
                >
                  {isLoading && <Spinner />}
                  {
                    <img
                      style={{
                        maxWidth: "100%",
                        height: "100%",
                        maxHeight: "500px",
                        margin: "auto",
                      }}
                      src={att.url}
                      alt={att.name}
                      onLoad={handleImageLoad}
                      onError={handleImageError}
                    />
                  }{" "}
                  <br />
                  <h6 className="text-center font-bold mt-5">
                    {att.file_name}
                  </h6>
                </div>
              ))}
          </Col>

          <Col md="1" className="text-center">
            <Button
              style={{ ...btnStyle }}
              disabled={attachments.length <= 1}
              onClick={() => handleSlideChange("next")}
            >
              <KeyboardArrowRight />
            </Button>
          </Col>
        </Row>
      </Container>
    </Modal>
  );
};

export default AttachmentModal;
